import Vue from 'vue';
import moment from 'moment';

// Axios uses JSON.Stringify which by default converts the DateTime objects to UTC
// To prevent this we override the toJSON function so it gets the string properly
Date.prototype.toJSON = function() {
  return moment(this).format();
};

const templates = {
  default: 'DD/MMM/YYYY',
  numberMonthDayYear: 'MM/DD/YYYY',
  hour: 'hh:mm a',
  hourWithWeekDay: 'ddd hh:mm a',
  longDateFormat: 'dddd, DD MMMM YYYY',
  longDateWithHour: 'DD/MMM/YYYY hh:mm a',
};

Object.defineProperty(String.prototype, 'hours', {
  get() {
    if (this?.length > 0) {
      const hour = moment(this, 'HH:mm:ss').hours();
      return hour;
    }

    return '';
  },
});

Object.defineProperty(String.prototype, 'minutes', {
  get() {
    if (this?.length > 0) {
      const minute = moment(this, 'HH:mm:ss').minutes();
      return minute;
    }

    return '';
  },
});

export default {
  install() {
    Vue.prototype.$templateDate = templates;

    Vue.prototype.$formatDate = (date, template = templates.default) => {
      if (date == null) {
        return '';
      }

      let result = moment(date)
        .locale('es-PR')
        .format(template)
        .replace(/ 0(?:0)?/, ' '); //Removing leading '0' from hour

      return result;
    };
  },
};
